var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-info-root",class:{border: _vm.border,warning: _vm.warning,danger: _vm.danger}},[(_vm.ico)?_c('w-fa',{attrs:{"size":_vm.icoSize,"icon":[_vm.icoLib, _vm.ico]}}):_vm._e(),_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.text),expression:"text"}]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }